<template>
  <div  >
    <h5 class=" font-weight-regular mb-1"
        :style="`color : ${inputErrors.paymentPlan ? wsWARNING : wsACCENT}`"
    >
      {{  $t('SubscriptionPeriod')  }}
    </h5>
    <div  :style="`border: 1px solid ${inputErrors.paymentPlan ? wsWARNING : wsBACKGROUND}; background-color: #ffffff`">
      <div @click="entityData.quantity = plan.value; inputErrors.quantity = null"
           v-for="(plan,index) in timePeriodsSelect" :key="index + 'wave'"
           class="pa-2 d-flex align-center  pointer"
           :style="index > 0 ? 'border-top: 1px solid var(--wsBACKGROUND)' : null"
      >
        <v-icon class="mr-2" :color="wsACCENT">{{ entityData.quantity === plan.value ?  'mdi-radiobox-marked' : 'mdi-radiobox-blank' }}</v-icon>

        <h5 class="wsACCENT">{{ plan.text }}</h5>

      </div>
    </div>



  </div>
</template>

<script>
export default {
  name: "courseSubscription",
  components : {

  },
  props : {
    value : {
      type : Object,
      default() {
        return {}
      }
    },
    entity : {
      type : Object,
      default() {
        return {}
      }
    },
    promocodeDiscount : {
      type : Number,
      default : 0
    },
    inputErrors : {
      type : Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      entityData : {}
    }
  },

  computed : {
    timePeriodsSelect() {
      if ( !this.entity.time_periods_select) {
        return []
      }
      let items = []

      this.entity.time_periods_select.forEach((period)=>{
        let type = this.entity.time_period_type
        let quantity = type === 'custom' ? (period * this.entity.time_period_days ) : period
        type = type === 'custom' ? 'day' : type
        if (type === 'month') {
          type = '_month'
        }

        let text = this.$tc(type , quantity);
        let periodDiscount = this.getPeriodDiscount(period)
        if ( periodDiscount && periodDiscount > this.entity.discount && periodDiscount > this.promocodeDiscount ) {
          text = text + ` (${this.$t('Discount')} : ${this.getPeriodDiscount(period) }%)`
        }

        items.push({
          text : text ,
          value : period
        })
      })
      return items
    },
  },

  watch : {
    value : {
      handler() {
        if (!this.EQ(this.value , this.entityData)) {
          this.entityData = this.COPY(this.value)
        }
      },
      deep : true
    },
    entityData : {
      handler() {
        if (!this.EQ(this.value , this.entityData)) {
          this.$emit('input' , this.COPY(this.entityData))
        }
      },
      deep : true
    }
  },

  methods : {
    getPeriodDiscount(period) {
      if (!this.entity.periods_discount || this.entity.periods_discount.length === 0) {
        return null
      }
      let periodDiscount = this.entity.periods_discount.find(el => el.period === period )
      return periodDiscount ? periodDiscount.percent :  null
    },
  },

  mounted() {
    if (this.value) {
      this.entityData = this.COPY(this.value)
    }

    if (this.timePeriodsSelect && this.timePeriodsSelect.length) {
      this.entityData.quantity = this.timePeriodsSelect[0].value
    }

  }
}
</script>



<style scoped>

</style>